import axios from 'axios'
import { bearerToken } from '../components/auth/authorisation'

const useSecuredApiService = () => {
  const getSelectedImporterId = () => {
    const selectedImporterId = localStorage.getItem('selectedImporterId')

    if (
      !selectedImporterId ||
      selectedImporterId === 'null' ||
      selectedImporterId === 'undefined'
    ) {
      return null
    }
    return selectedImporterId
  }

  const createRequest = async (responseType = 'json', isFormData = false) => {
    const token = await bearerToken()
    const selectedImporterId = getSelectedImporterId()

    const headers = {
      tenantId: selectedImporterId,
      Authorization: `Bearer ${token}`,
      Accept: responseType === 'blob' ? 'application/zip' : 'application/json',
      ...(isFormData ? {} : { 'Content-Type': 'application/json' }),
    }

    return axios.create({
      baseURL: process.env.REACT_APP_API_URL_UAT,
      headers,
      responseType,
    })
  }

  const getApiDataWithParams = async (url, params) => {
    const request = await createRequest()
    return request.post(url, params)
  }

  const getApiData = async (url) => {
    const request = await createRequest()
    return request.get(url)
  }

  const postApiData = async (url, data, responseType = 'json') => {
    const isFormData = typeof FormData !== 'undefined' && data instanceof FormData
    const request = await createRequest(responseType, isFormData)

    return request.post(url, data)
  }

  const putApiData = async (url, data) => {
    const request = await createRequest()
    return request.put(url, data)
  }

  const patchApiData = async (url, data) => {
    const request = await createRequest()
    return request.patch(url, data)
  }

  const deleteApiData = async (id) => {
    const request = await createRequest()
    return request.delete(id)
  }

  const putApiFormData = async (url, data, saveNo, callback) => {
    const request = await createRequest()

    request
      .put(url, data)
      .then((response) => {
        callback(saveNo, response.status === 200)
      })
      .catch(() => {
        callback(saveNo, false)
      })
  }

  const postApiFormData = async (url, id, json, saveNo, callback) => {
    const request = await createRequest()

    request
      .post(url, { id: id, title: json.title, data: JSON.stringify(json) })
      .then((response) => {
        callback(saveNo, response.status === 200)
      })
      .catch(() => {
        callback(saveNo, false)
      })
  }

  const getApiBlob = async (filename) => {
    const token = await bearerToken()
    const selectedImporterId = getSelectedImporterId()

    const request = axios.create({
      baseURL: process.env.REACT_APP_API_URL_UAT,
      headers: {
        tenantId: selectedImporterId,
        Authorization: `Bearer ${token}`,
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'Content-Disposition': 'attachment; filename=file.pdf',
      },
    })

    return request.get(filename, { responseType: 'arraybuffer' })
  }

  return {
    getApiDataWithParams,
    getApiData,
    postApiData,
    putApiData,
    patchApiData,
    deleteApiData,
    putApiFormData,
    postApiFormData,
    getApiBlob,
  }
}

export default useSecuredApiService
